export default __webpack_public_path__ + "static/media/medicalexpenses.44fea594.jpg";